<se-fe-card class="yso-product">
  <se-fe-card-content class="yso-product__content card-content">
    <div class="card-content__image">
      <img [src]="image.src" alt="{{ image.alt || '' }}" />
    </div>
    <app-yso-product-info
      class="card-content__product-info"
      [product]="item()"></app-yso-product-info>
  </se-fe-card-content>
  <se-fe-card-footer class="yso-product__footer">
    <se-fe-button
      class="add-to-cart"
      aria-label="Select options"
      seFeDataEmphasis="medium"
      (click)="openModal()">
      <span class="add-to-cart__text">Select options</span>
    </se-fe-button>
  </se-fe-card-footer>
</se-fe-card>

<se-fe-modal
  seFeDataSize="large"
  #productModal
  (seFeClose)="resetFormControls()">
  <div seFeModalHeader>
    <se-fe-modal-header
      [seFeDataTitle]="'Choose Product Options'"></se-fe-modal-header>
  </div>

  <div seFeModalContent>
    @if (item().type === 'Bundle') {
      <section class="yso-bundle-details">
        <!-- Bundle Header -->
        <div class="bundle-header">
          <div class="bundle-header__image">
            <img [src]="image.src" alt="{{ image.alt || '' }}" />
          </div>
          <div class="bundle-header__info">
            <div class="bundle-header__name">{{ item().name }}</div>
            <div class="bundle-header__price">
              {{ item().price | currency }}
            </div>
            <div class="bundle-header__quantity">Quantity: 1</div>
            <div
              class="bundle-header__description ql-editor"
              [innerHTML]="item().description"></div>
          </div>
        </div>

        <app-divider></app-divider>

        <!-- Products in Bundle -->
        <div class="bundle-products">
          @for (product of item().products; track product.id; let i = $index) {
            <app-yso-bundle-item
              [product]="product"
              [specificationMap]="specificationMapValue()"
              [variants]="getVariantsForProduct(product.id)"
              [isExpanded]="isExpanded(product.id)"
              (formReady)="onBundleFormReady(i, $event)"
              (toggleDetails)="toggleDetails(product.id)"></app-yso-bundle-item>
          }
        </div>
      </section>
    } @else {
      <section class="yso-product-details">
        <div class="yso-product-details__image product-image">
          @if (carouselContentConfig(); as config) {
            <se-fe-carousel
              [seFeDataConfig]="carouselConfig"
              [seFeDataContent]="config">
              <ng-template seFeCarouselSlide let-slide>
                <img
                  [src]="slide.src"
                  alt="{{ slide.alt || 'Product image' }}" />
              </ng-template>
            </se-fe-carousel>
          } @else {
            <img [src]="image.src" alt="{{ image.alt || '' }}" />
          }
        </div>
        <div class="yso-product-details__info">
          <app-yso-product-info [product]="item()"></app-yso-product-info>
        </div>
        <app-yso-product-form
          #productForm
          [product]="item()"
          [specificationMap]="specificationMap"
          [variantsInput]="variants()"
          (formReady)="onFormReady($event)"
          class="yso-product-details__form"></app-yso-product-form>
        <div class="yso-product-details__description description">
          @if (item().description) {
            <app-divider></app-divider>
          }
          <div
            class="description__text ql-editor"
            [innerHtml]="item().description"
            style="word-break: break-word"></div>
        </div>
      </section>
    }
  </div>

  <div seFeModalFooter>
    <se-fe-modal-footer
      #modalFooter
      [seFeDataFooterButtons]="itemDetailFooterButtons()"></se-fe-modal-footer>
  </div>
</se-fe-modal>
